/* eslint react-hooks/rules-of-hooks: "warn" */
import {
  type SelectOptionType,
  type SelectOptionTypeIntl,
} from 'domains/merchandising/types/heroBanner.types'
import { useDashMessage } from 'intl/intl.hooks'

export const useSelectOptionsDashMessage = (options: SelectOptionType[]): SelectOptionTypeIntl[] =>
  options.map(({ value, labelKey }) => ({ value, label: useDashMessage(labelKey) }))

export const useSelectOptionsDashMessages = (optionsObj: { [key: string]: SelectOptionType[] }) =>
  Object.fromEntries(
    Object.entries(optionsObj).map(entry => [entry[0], useSelectOptionsDashMessage(entry[1])])
  )
